// Lösenordspolicyn på ETT ställe för alla formulär som validerar före anropet.
// Facit är alltid auth-serverns Identity-options (LWCX.AuthorizedServer/Program.cs:
// minst 8 tecken, versal, gemen, siffra). Teckenlistan här är dessutom snävare än
// Identity — inga å/ä/ö och ett urval specialtecken — vilket är den etablerade
// regeln i formulären sedan tidigare (jfr CommonTexts.PassWordRequirements).
// Ändras kraven: uppdatera auth-servern, mönstren här och prosatexterna
// (CommonTexts + i18n-hintarna) — inget annat.

export const PASSWORD_PATTERN =
  /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\\"()\\[\]-]{8,25}$/;

// Separat längdkontroll så formulären kan visa ett eget, tydligare meddelande
// för för korta lösenord än det generella formatfelet.
export const PASSWORD_MIN_LENGTH_PATTERN = /^.{8,}$/;

// Uppfyller policyn ovan med marginal. Tecken som lätt förväxlas (l/1, O/0) är
// bortplockade — lösenordet ska kopieras till en tjänstekonfiguration av en människa.
export const generatePassword = () => {
  const lower = "abcdefghjkmnpqrstuvwxyz";
  const upper = "ABCDEFGHJKMNPQRSTUVWXYZ";
  const digits = "23456789";
  const special = "!#%&*+-=?@";
  const all = lower + upper + digits + special;

  const pick = (source) =>
    source[crypto.getRandomValues(new Uint32Array(1))[0] % source.length];

  const chars = [pick(lower), pick(upper), pick(digits), pick(special)];
  while (chars.length < 16) {
    chars.push(pick(all));
  }

  for (let i = chars.length - 1; i > 0; i--) {
    const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join("");
};
